import React from "react";
import { IUserRef } from "../../models/userData.model";
import { User, Calendar, XCircle } from "lucide-react";
import Button, { ButtonType } from "../../components/Assets/Button";
interface TaskManagerFiltersProps {
  users: IUserRef[];
  assigneeFilter: string;
  followerFilter: string;
  authorFilter: string;
  startDateFilter: string;
  endDateFilter: string;
  openAddTaskModal: (isOpen: boolean) => void;
  onAssigneeChange: (assigneeId: string) => void;
  onFollowerChange: (followerId: string) => void;
  onAuthorChange: (authorId: string) => void;
  onStartDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEndDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearDates: () => void;
}

const TaskManagerFilters: React.FC<TaskManagerFiltersProps> = ({
  users,
  assigneeFilter,
  followerFilter,
  authorFilter,
  startDateFilter,
  endDateFilter,
  onAssigneeChange,
  onFollowerChange,
  onAuthorChange,
  onStartDateChange,
  onEndDateChange,
  onClearDates,
  openAddTaskModal,
}) => {
  return (
    <div className="bg-white  p-3 rounded-xl shadow-sm border border-gray-200 md:inline-flex items-end gap-4 mb-6 mt-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        <div className="flex flex-col">
          <label
            htmlFor="assignee-filter"
            className="flex items-center gap-1 text-xs font-semibold text-gray-700 mb-1"
          >
            <User className="w-4 h-4 text-gray-500" />
            Assignee
          </label>
          <select
            id="assignee-filter"
            value={assigneeFilter}
            onChange={(e) => onAssigneeChange(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 
                 hover:border-blue-400 transition"
          >
            <option value="">All Assignees</option>
            {users?.map((user) => (
              <option key={user._id} value={user._id}>
                {user.username.capitalizeWords()}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="follower-filter"
            className="flex items-center gap-1 text-xs font-semibold text-gray-700 mb-1"
          >
            <User className="w-4 h-4 text-gray-500" />
            Follower
          </label>
          <select
            id="follower-filter"
            value={followerFilter}
            onChange={(e) => onFollowerChange(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 
                 hover:border-blue-400 transition"
          >
            <option value="">All Followers</option>
            {users?.map((user) => (
              <option key={user._id} value={user._id}>
                {user.username.capitalizeWords()}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="author-filter"
            className="flex items-center gap-1 text-xs font-semibold text-gray-700 mb-1"
          >
            <User className="w-4 h-4 text-gray-500" />
            Author
          </label>
          <select
            id="author-filter"
            value={authorFilter}
            onChange={(e) => onAuthorChange(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs 
         focus:outline-none focus:ring-2 focus:ring-blue-500 
         hover:border-blue-400 transition"
          >
            <option value="">All Authors</option>
            {users?.map((user) => (
              <option key={user._id} value={user._id}>
                {user.username.capitalizeWords()}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="start-date"
            className="flex items-center gap-1 text-xs font-semibold text-gray-700 mb-1"
          >
            <Calendar className="w-4 h-4 text-gray-500" />
            Start Date
          </label>
          <input
            type="date"
            id="start-date"
            value={startDateFilter}
            onChange={onStartDateChange}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 
                 hover:border-blue-400 transition"
          />
        </div>

        <div className="flex flex-col">
          <label
            htmlFor="end-date"
            className="flex items-center gap-1 text-xs font-semibold text-gray-700 mb-1"
          >
            <Calendar className="w-4 h-4 text-gray-500" />
            End Date
          </label>
          <div className="flex items-center gap-2">
            <input
              type="date"
              id="end-date"
              value={endDateFilter}
              onChange={onEndDateChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 
                   hover:border-blue-400 transition"
            />
            {(startDateFilter || endDateFilter) && (
              <button
                onClick={onClearDates}
                className="flex items-center gap-1 px-3 py-2 text-xs text-red-600 bg-red-50 
                     hover:bg-red-100 rounded-lg transition"
              >
                <XCircle className="w-4 h-4" />
                Clear
              </button>
            )}
          </div>
        </div>
        <div className="flex flex-col justify-end">
          <Button
            type={ButtonType.Submit}
            onClick={() => openAddTaskModal(true)}
            className="text-sm"
          >
            Add Task
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TaskManagerFilters;
